import React,{Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {AsyncTypeahead, Typeahead} from 'react-bootstrap-typeahead';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import moment from 'moment';

import {user} from 'react-icons-kit/icomoon/user';
import {Table, Link, Panel} from 'react-bootstrap';

import SvgIcon from 'react-icons-kit';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import Icon from "../petition_register/Components/MatrazIcon";
import {download2} from 'react-icons-kit/icomoon/download2';
import {upload2} from 'react-icons-kit/icomoon/upload2';
import {drop} from 'react-icons-kit/entypo/drop';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import {history} from 'react-icons-kit/icomoon/history'
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../generics/modal_person_search';


import ModalSample from './modalSample';
import ModalSampleResult from '../petition_register/modalSampleResult';
import ModalReserve from '../petition_register/modalReserve';
import ModalSend from './modalSend';
import ModalGpoRh from './modalGpoRh';
import ModalUserTraceability from '../../offers/userTraceability';

import RaisedButton from 'material-ui/RaisedButton';

import ModalNotes from '../petition_register/Components/modalNotes';
import Help from '../../generics/help';
import {print} from 'react-icons-kit/fa/print';
import { Card } from 'reactstrap';
import ModalGeneralTraceability from '../../generics/modalGeneralTraceability';
import {heartbeat} from 'react-icons-kit/fa/heartbeat'
import ModalConditions from '../petition_register/Components/modalConditions';

const {htmlToText} = require('html-to-text');

var Config = require('../../../config');
const $ = require('jquery');

class PatientSearch extends Component{
	constructor(props){
		super(props);

		this.patientSelected = this.patientSelected.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.openGroups = this.openGroups.bind(this);
		this.filter = this.filter.bind(this);
		this.addNotes = this.addNotes.bind(this);
		this.save_patient = this.save_patient.bind(this);
		this.sendProducts = this.sendProducts.bind(this);
		this.person_search = this.person_search.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.getNextPatient = this.getNextPatient.bind(this);
		this.openGeneralTraceability = this.openGeneralTraceability.bind(this);
		this.openConditions = this.openConditions.bind(this);
		this.getNotes = this.getNotes.bind(this);

		this.state = {
			patients:[],
			person_id:"",
			loading_patient:false,
			disableFields:false,
			patient_name:"",
			patient_lastname1:"",
			patient_lastname2:"",
			patient_id:"",
			patient_sex:"",
			birthdate:"",
			age:"",
			last_unit_date:"",
			documents:[],
			document_id:"",
			document_type:"DOCUMENT_INE",
			document_number:"",
			social_number:"",
			clinic_history:"",
			unit_reserved:"",
			phenotypes:"",
			lookup_rh:"",
			lookup_group:"",
			lectina:"",
			du:"",
			rhGroup:[],
			rh_group:"",
			petitions:[],
			antibodies:"",
			filter:"",
			disable_save:true,
			alerts:[],
			rai:"",
			notes:[],
			deliveries:[],
			samples:[],
			reserves:[],
			rai:"",
			rai_date:"",
			patient_number:"",
			pac_usr_npm:"",
			flag_condition: false,
			pat_pet_cond:{},
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		$(document).on('click', '.panel-heading', function(e){

			var panel = $(this).parent('.panel-default').children('div').eq(1);
			var length = panel.children('div').children('div').length === 1 ?
							panel.children('div').children('div').children('table').children('tbody').children('tr').length
						: panel.children('div').children('div').eq(1).children('div').children('table').children('tbody').children('tr').length;
			
			if(length > 0){
				if(panel.hasClass('in')){
					panel.removeClass('in');
				}else{
					panel.addClass('in');
				}
			}
			
			
		});

		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.dateHandleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_PET_COND', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_pet_cond:response.value});      					
      		}
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAC_USR_NPM', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pac_usr_npm:response.value});      	

      			
      			if(response.value === 'YES'){
					this.setState({patient_number:""});
				}else{
					this.getNextPatient();
				}				
      		}
		  });


		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({documents:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		});

		if(this.props.match.params.patient_id !== undefined){
			this.infoPatient(this.props.match.params.patient_id);
			this.patientSelected([{id:this.props.match.params.patient_id}])
			
		}
	}

	getNextPatient(){
		fetch(Config.default.apiGateway.URL+'patients/next_patient_number', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({patient_number: response})
			}
		})
	}

	handleChange(e){
		if(e.target.type === 'checkbox'){
			this.setState({
				[e.target.name]: e.target.checked ? false : true,
				disable_save: e.target.checked ? false : true
			});
		}else{

			this.setState({[e.target.name]: e.target.value});	

			if(e.target.name === 'birthdate'){
				var control = document.getElementById(e.target.id);
				
				if(e.target.value.length === 10 && e.target.value.indexOf('_') === -1){
					control.classList.remove('error');
			    	this.calcularEdad(e.target.value, control);
				}else{
					if(e.target.value === ""){
						control.classList.remove('error');
						this.setState({age: ""});
					}else{
						control.classList.add('error');
					}
				}
			}
			
		}
	}

	getNotes(id){
		fetch(Config.default.apiGateway.URL+'petition_notes/alerts?patient_id='+id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error!', error, 'error');
			  });
			}
		})
		.then(response =>{
			if(response !== null && response !== undefined){
				if(response.alert !== null){
					
					if(response.alert.indexOf('<p>') === -1){
						swal('Alerta', htmlToText(response.alert), 'error');
					}else{
						swal({
							title: 'Alerta',
							html:true,
							text: response.alert,
							type: 'error',	
						});
					}


					
				}


				if(response.total > 0){

					this.setState({has_notes:true});
				}
			}
		})
	}

	_handleSearchPatient = (query)=>{
		this.setState({loading_patient: true, patient_id:"", person_id:""});
	    
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}

					if(response[i].social_number !== null){
						response[i].names += ' '+response[i].social_number
					}
					
					response[i].id = response[i].patient_id;
				};

				this.setState({
					loading_patient: false,
			     	patients: response,
			    });

			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});

			    		var index = this.state.patients.findIndex(obj => 
			    			 parseInt(obj.person.id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.patientSelected([this.state.patients[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			}
		})
	}

	patientSelected(e){
		var id = "";
		this.setState({
	     	patient_id: "",
	     	person_id: "",
			patient_name: "",
			patient_lastname1: "",
			patient_lastname2: "",
			clinic_history: "",
			age:"",
			patient_sex:"",
			lectina:"",
			du:"",
			phenotypes:"",
			antibodies:"",
			document_type:'DOCUMENT_INE',
			document_number:"",
			document_id:"",
			lookup_group:"",
			lookup_rh:"",
			alerts:[],
			rai:"",
			rai_date:""
	    });
		if(e.length > 0){

			if(e[0].patient === undefined){
				fetch(Config.default.apiGateway.URL+'patients/patient_offer?id='+e[0].id,{
			   		method:'GET',
			   		headers: new Headers({
			   			'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
			   			'Accept'		: 'application/json',
			   			'Content-Type'	: 'application/json'
			   		})
			   	}).then(res => {
			   		this.props.waiting.handleClose();
			   		if(res.ok){
			   			return res.json();
			   		}else{
			   			res.text().then((msg)=>{
			   				swal('Error', msg, 'error');
			   			});
			   		}
			   	}).then(response => {
			   		if(response !== undefined){
						this.patientSelected([response]);
		    			return;
			   		}
			   	})
			}else{
				id = e[0].id !== undefined ? e[0].id : e[0].patient.id;
				this.setState({
					patient_id: id,
					person_id:e[0].person.id,
					patient_name: e[0].person.names,
					patient_lastname1: e[0].person.lastname1,
					patient_lastname2: e[0].person.lastname2,
					clinic_history: e[0].patient.number,
					social_number: e[0].person.social_number,
					disableFields: true,
					
					birthdate: e[0].person.birthday !== null ? moment(e[0].person.birthday).format('DD/MM/YYYY') : '',
					lookup_group: e[0].person.lookup_group,
					lookup_rh: e[0].person.lookup_rh,
					loading_patient:false,
					samples: e[0].all_samples !== undefined ? e[0].all_samples 
								: this.state.samples.length > 0 ? this.state.samples : [],
					patient_sex:e[0].person.sex,
					rai:e[0].rai,
					rai_date:moment(e[0].rai_date).format('DD/MM/YYYY HH:mm'),
					patient_number: e[0].patient.patient_number
				});

				if(this.props.match.params.patient_id === undefined){
					this.infoPatient(id);
				}

				if(this.state.pat_pol_trans === 'YES'){
					this.setState({
						politransfused: e[0].patient.politransfused !== null ? e[0].patient.politransfused : false
					});
					
				}

				if(e[0].person.birthday !== null){
					var control = document.getElementById('birthdate');
				
					this.calcularEdad(e[0].person.birthday, control);
				}

				this._typeahead.getInstance().clear();

				setTimeout(()=>{
					this.setState({
						clinic_history_list:[],
						patient_list: [],
					});
				}, 500);

				this.getList(id);
			}
				
				
		}
	}

	getList(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'petitions/by_patient?patient_id='+id,{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json',
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					petitions:response
				})
			}
		})
	}

	infoPatient(id){
		fetch(Config.default.apiGateway.URL+'patients/'+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				response.notes.map((n)=>{
					n.note = n.note.replace(/<p>/g, '')
									.replace(/<font size="6">/g, '')
									.replace(/<font size="7">/g, '')
									.replace(/<\/font>/g, '')
									.replace(/<strong>/g, '')
									.replace(/<\/strong>/g, '')
									.replace(/<\/p>/g, '\n')
									.replace(/<br>/g, '\n')
									.replace(/<\/br>/g, '\n');
				});

				this.setState({
					document_id: response.document !== undefined && response.document !== null ? 
									response.document.id : "",
					document_type: response.document !== undefined && response.document !== null ? 
									response.document.document_type : "",
					document_number: response.document !== undefined && response.document !== null ? 
									response.document.document_number : "" ,
					last_unit_date:response.last_unit_delivered,
					unit_reserved:response.unit_reserved,
					flag_notes:response.flag_notes,
					notes: response.notes,
					samples: response.samples,
					deliveries: response.units_delivered_detail,
					reserves: response.reserves,
					flag_condition: response.flag_conditions,
					lectina: response.person.lookup_lectin !== null ? response.person.lookup_lectin : ""
				});

				if(response.test_result !== null){
					response.test_result.map((res)=>{
						if(res.name.toUpperCase() === 'LECTINA'){
							//this.setState({lectina:res.value});
						}

						if(res.name.toUpperCase() === 'DU'){
							this.setState({du:res.value});
						}

						if(res.name.toUpperCase() === 'RASTREO DE ANTICUERPOS IRREGULARES'){
							this.setState({rai:res.value});
						}
					})

				}
					

				var phen = '';
				response.phenotype.map((p, i)=>{
					phen += p.phenotype1+p.result+( i === response.phenotype.length -1 ? '' : ', ')
				})

				var anti = '';
				response.antibodys.map((a)=>{
   					return a.result === "1" ?
    					anti += a.antibody+',  '
     				:null
    			});

				this.setState({phenotypes: phen, antibodies: anti});

				if(this.props.match.params.patient_id !== undefined){
					//this.patientSelected([response]);
				}

				this.getNotes(id);
			}
		});
	}

	calcularEdad(fecha, control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
		    }else{
		    	this.setState({age:'', birthdate:''});	
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		    
		}
	}

	newSample(id, patient_id, sample_id){
  		this.modal_sample.handleShow(id, patient_id, sample_id);
  	}

  	sampleResults(e,item){
		e.preventDefault();
		
		this.modal_sample_result.handleShow(item.id);	
	}

	unitReserve(e, id){
  		//this.props.history.push('/petition_register/reserve/'+id);
  		this.modal_reserve.handleShow(id);
  	}

  	sendUnits(e, id){
		this.modal_send.handleShow(id);
		//this.props.history.push('/petition_register/unitSend/'+id);
	}

	onReturn(){
		this.props.history.push('/');
	}

	concatGroupRH(){
		var res = "";

		if(this.state.lookup_rh==="POSITIVO"){
			res = this.state.lookup_group+'+'
		}else if(this.state.lookup_rh==="NEGATIVO"){
			res = this.state.lookup_group+'-'
		}else{
			res = (this.state.lookup_group !== null ? this.state.lookup_group : '') +'';
		}

		return res;
	}

	openGroups(e, item){
		this.modal_group.handleShow(item);
	}

	filter(row){
		var res = true;


		var find = row.id+' '+row.name+' ';

		row.g_rh.map((g)=>{
			find += g.group+(g.rh === 'POSITIVO' ? '+' : g.rh === 'NEGATIVO' ? '-' : "")+' ';

			g.samples.map((s)=>{
				find += s.number+' ';
			});
		});


		if(this.state.filter === ""){
			res = true;
		}else{
			if(find.indexOf(this.state.filter.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
		}

		return res;
	}

	addNotes(e){
		e.preventDefault();
		this.modal_notes.handleShow(this.state.patient_id, 'search');
	}

	save_patient(){
		var birth = moment(this.state.birthdate, 'DD-MM-YYYY');

		var documents = {
			document_number:this.state.document_number,
			document_type:this.state.document_type,
			person_id: this.state.person_id
		};

		if(this.state.document_id !== ""){
			documents.id = this.state.document_id;
		}

		var obj = {
			id:this.state.patient_id,
			number:this.state.clinic_history,
			person_id:this.state.person_id,
			person:{
				person_type:'PATIENT',
				id:this.state.person_id,
				names:this.state.patient_name,
				lastname1:this.state.patient_lastname1,
				lastname2:this.state.patient_lastname2,
				birthday: this.state.birthdate !== "" ?
							birth.format('MM-DD-YYYY') !== 'Invalid date' ? 
								birth.format('MM-DD-YYYY') 
							: ""
						: null,
				sex:this.state.patient_sex,
				social_number:this.state.social_number,
				lookup_group: this.state.lookup_group,
				lookup_rh: this.state.lookup_rh,
				documents:[documents]
			},
			patient_number: this.state.patient_number
		}

		this.props.waiting.handleShow('Guardando...');

		fetch(Config.default.apiGateway.URL+'patients/'+this.state.patient_id, {
			method:'put',
			body: JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res =>{
			this.props.waiting.handleClose();
			if(res.ok){
				return 'ok';
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({disableFields:true});
				swal('Proceso terminado', 'Se actualizaron los datos correctamente', 'success');
			}
		});

		
	}

	userTraceability(e){
		e.preventDefault();

		this.modal_user_traceability.handleShow(this.state.person_id);
	}

	sendProducts(e, id){
		this.props.history.push({
			pathname:'/plasmatic_products/despatch/'+id,
			state:{
				from:'patient_search',
				patient_id:this.state.patient_id
			}
		});
	}

	person_search(){
		this.modal_person_search.handleShow('Paciente','patients');
	}

	async onPrint(e){
		e.preventDefault();

		this.props.waiting.handleShow('Imprimiendo...');
					
		var obj ={
			health_facilities_id: parseInt(sessionStorage.getItem("health_facilities_id"),10),
			id: this.state.patient_id,
			file_type: "patient_history",
			nEtiqueta: [0]
		};
		
		

		var type =  await this.props.getDocumentType(obj.file_type);
		
		
		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}
	
		this.props.waiting.handleClose();
		
	}

	openGeneralTraceability(e){
		e.preventDefault();

		this.modal_general_traceability.handleShow(this.state.person_id, 'patient');
	}
	
	openConditions(e){
		e.preventDefault();

		this.modal_conditions.handleShow(this.state.patient_id, "", 'patient_search');
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Buscar paciente
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_patient_search"}  />
				<form noValidate>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-7">
					 			<span className="span-min">{t('content.generics.buttons.search')}</span>
						        <AsyncTypeahead
						          labelKey={(option) => `${option.names}`}
						          minLength={3}
						          maxLength={50}
						          name="patient"
						          id="patient"
						          onSearch={this._handleSearchPatient}
						          placeholder="Buscar por apellidos más nombre o número de documento..."
						          options={this.state.patients}
						          onChange={this.patientSelected}
						          ref={ref => this._typeahead = ref}
						          useCache={false}
						          isLoading={this.state.loading_patient}
						          delay={600}
						          paginationText="Mostrar mas resultados..."
						        />
					 			
						</div>
						<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
							<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
								onClick={this.person_search}/>
						</div>
						
					</div>
					<fieldset className="col-xs-12">
						<legend>Paciente</legend>
						<div className="col-xs-12"><SvgIcon size={25} icon={user}/></div>
						<div className="col-xs-12">
							{this.state.patient_id !== "" ?
								<div className="col-xs-12">
									<input className="form-check-input" type="checkbox" name="disableFields" id="disableFields"
										style={{marginRight: "5px"}} value={this.state.disableFields} 
										onChange={this.handleChange}/>
									<span className="span-min">Editar Datos</span>
								</div>
							:null}

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Nombre(s)</span>
								{this.state.disableFields}
								<input className="form-control" type="text" name="patient_name" id="patient_name" 
									value={this.state.patient_name || ""} 
								   	onChange={this.handleChange} disabled={this.state.disableFields}	/>
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">A. Paterno</span>

								<input className="form-control" type="text" name="patient_lastname1" id="patient_lastname1"
									value={this.state.patient_lastname1 || ""}
									 onChange={this.handleChange} 
									disabled={this.state.disableFields} />
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">A. Materno</span>

								<input className="form-control" type="text" name="patient_lastname2" id="patient_lastname2" value={this.state.patient_lastname2 || ""}
								 	 onChange={this.handleChange} disabled={this.state.disableFields} />
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">F. Nacimiento</span>

								<MaskedFormControl type='text' name="birthdate" id="birthdate" value={this.state.birthdate || ""}
		          					onChange={this.handleChange} mask='11/11/1111' placeholder="dd/mm/yyyy" 
		          					className="form-control input-date" disabled={this.state.disableFields}/>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Edad</span>

								<input className="form-control" type="text" name="age" value={this.state.age || ""} disabled />
							</div>

							<div className="col-xs-12 col-sm-1" style={{width:'8.3%', position:'absolute', left:'67%'}}>
								<span style={{color:"red", fontSize:"5em"}}>
									{this.concatGroupRH()}
								</span>
							</div>
							
							<div className="col-xs-12 col-sm-3" style={{left:'10%'}}>	
								{this.state.lookup_group!=="" && this.state.lookup_group !== null?
									<div style={{position:'absolute'}}>
										{this.state.lectina !== "" ?
											<div>
												<span className="span-min" >Subgrupo</span>
												<span style={{color:"red", fontSize:"2em", marginLeft:"10px"}}>
													{this.state.lectina !== 'NO PROCESADO' ? this.state.lectina : ''}
												</span>
											</div>
										:null}
										{this.state.du !== "" ?
											<div >
												<span className="span-min">Variante Débil (DU)</span>
												<span style={{color:"red", fontSize:"14px", marginLeft:"10px"}}>
													{this.state.du}
												</span>
											</div>
										:null}
										{this.state.phenotypes !== "" ?
											<div >
												<span className="span-min">Fenotipos</span>
												<span style={{color:"#0008ff", fontSize:"14px", marginLeft:"10px", fontWeight:'bold'}}>
													{this.state.phenotypes}
												</span>
											</div>
										:null}
										{this.state.antibodies !== "" ?
											<div >
												<span className="span-min">Anticuerpos</span>
												<span style={{color:"red", fontSize:"14px", marginLeft:"10px", fontWeight:'bold'}}>
													{this.state.antibodies}
												</span>
											</div>
										:null}
										{this.state.rai !== "" ?
											<div >
												<span className="span-min">RAI</span>
												<span style={{color:"red", fontSize:"12px", marginLeft:"10px", fontWeight:'bold'}}>
													{this.state.rai}
												</span>
											</div>
										:null}
										{this.state.rai !== "" ?
											<div >
												<span className="span-min">Fecha RAI</span>
												<span style={{fontSize:"12px", marginLeft:"10px", fontWeight:'bold'}}>
													{this.state.rai_date}
												</span>
											</div>
										:null}
											
									</div>
								:null}
							</div>
						</div>

						<div className="col-xs-12">

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Tipo Documento</span>
								<select name="document_type" className="form-control" value={this.state.document_type || ""} 
									
									onChange={this.handleChange} disabled={this.state.disableFields}>
									<option value="">Seleccione...</option>
									{this.state.documents.map((d, i)=>{
										return <option key={i} value={d.key}>
											{d.name}
										</option>
									})}
								</select>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">No. Doc.</span>
								<input className="form-control" type="text" name="document_number" id="document_number"
									disabled={this.state.disableFields} 
									value={this.state.document_number || ""} onChange={this.handleChange} />
							</div>
							<div className="col-xs-12 col-sm-1" >
								<span className="span-min">{t('content.offers.form.gender')}</span>
					            <select className="form-control" id="patient_sex" name="patient_sex"
					            	 disabled={this.state.disableFields}
					            	onChange={this.handleChange}
					            	value={this.state.patient_sex || ""} > 
							        <option value="" >Seleccionar...</option>
					                <option value="HOMBRE" >HOMBRE</option>
					                <option value="MUJER" >MUJER</option>
				              	</select>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min" style={{fontSize:"11px"}}>No. IMSS</span>

								<input className="form-control" type="text" name="social_number" id="social_number"
									disabled={this.state.disableFields} 
									value={this.state.social_number || ""} onChange={this.handleChange}/>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">No. Expediente</span>

								<input className="form-control" type="text" name="clinic_history" id="clinic_history"
									disabled={this.state.disableFields} 
									value={this.state.clinic_history || ""} onChange={this.handleChange} />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Número de Paciente</span>
								<input className="form-control hour-input"  
									name="patient_number" id="patient_number"
									disabled={this.state.disableFields ? true : this.state.pac_usr_npm === 'NO'}
									value={this.state.patient_number} onChange={this.handleChange} />
							</div>

						</div>
					</fieldset>

					

					<div className="col-xs-12 form-group" style={{textAlign:'center'}}>
		        		<RaisedButton disabled={this.state.disable_save} className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			onClick={this.save_patient}  style={{margin:12}}/>
		        	</div>

					<div className="col-xs-12 form-group" style={{textAlign:"center"}}>
						<button disabled={this.state.patient_id === ''} className="btn"
							style={this.state.flag_notes ? {color:'green', background:'transparent'} : {color:'#b8b8b8', background:'transparent'} }
							onClick={(e) => this.addNotes(e)} title="Notas">
							<SvgIcon size={40} icon={pencilSquareO} />
							<div className="col-xs-12">
								<span>{t('toolbar.save_notes')}</span>
							</div>
						</button>

						{this.state.pat_pet_cond === 'YES' &&
							<button className="btn" disabled={this.state.patient_id === ''} 
								onClick={(e)=>this.openConditions(e)}  
								style={this.state.flag_condition ?  {color:'rgb(var(--primary))', background:'transparent'} : {color: '#b8b8b8', background:'transparent'}}>
								<SvgIcon size={40} icon={heartbeat} />
								<div className="col-xs-12">
									<span>Condiciones</span>
								</div>
							</button>
						}

						<button disabled={this.state.patient_id === ''} className="btn"
							style={{background:'transparent'}}
							onClick={(e) => this.openGeneralTraceability(e)} title="Trazabilidad">
							<SvgIcon size={40} icon={history} />
							<div className="col-xs-12">
								<span>Trazabilidad</span>
							</div>
						</button>
					</div>

					<div className="col-xs-12">
						<Panel id="notes-panel">
							<Panel.Heading style={{
									background: this.state.notes.length > 0 ? 'var(--base1)' : '',
									color: this.state.notes.length > 0 ? 'var(--color-active)' : ''
								}}								
							>
								<Panel.Title toggle={this.state.notes.length > 0 ? true : false}>
									Notas
								</Panel.Title>
							</Panel.Heading>
							<Panel.Collapse>
								<Panel.Body>
									<Table responsive hover>
										<thead>
											<tr>
												<th>Fecha/Hr</th>
												<th>Usuario</th>
												<th>Proceso</th>
												<th>Tipo</th>
												<th>Texto de la nota</th>
											</tr>
										</thead>
										<tbody>
											{this.state.notes.map((n, i)=>(
												<tr key={i}>
													<td>{moment(n.timestamp).format('DD/MM/YYYY HH:mm')}</td>
													<td>{n.user}</td>
													<td>
														{n.process === 'PETITION' ? 'PETICIÖN' :
														n.process === 'LABORATORY_PATIENT' ? 'LABORATORIO' :
														n.process === 'SEARCH_PATIENT' ? 'BUSQUEDA DE PACIENTE' : ''}
													</td>
													<td>
														{n.type === 'NOTE' ? 'Nota': 'Alerta'}
													</td>
													<td>{htmlToText(n.note)}</td>
												</tr>
											))}
										</tbody>
									</Table>
								</Panel.Body>
							</Panel.Collapse>
						</Panel>

					
						<Panel id="petitions-panel">
							<Panel.Heading style={{
									background: this.state.petitions.length > 0 ? 'var(--base1)' : '',
									color: this.state.petitions.length > 0 ? 'var(--color-active)' : ''
							}}>
								<Panel.Title toggle ={this.state.petitions.length > 0 ? true : false}>
									Peticiones
								</Panel.Title>
							</Panel.Heading>
							<Panel.Collapse>
								<Panel.Body>
									<div className="col-xs-12 from-group" style={{margin:'10px 0px'}}>
										<div className="col-xs-12 col-sm-2">
											<input type="text" name="filter" id="filter" value={this.state.filter}
												onChange={this.handleChange} className="form-control" placeholder="Buscar..." />
										</div>
									</div>

									<div className="col-xs-12">
										<Table responsive hover>
											<thead>
												<tr>
													<th>Fecha</th>
													<th>No. Petición</th>
													<th>Tipo Peticion</th>
													<th>Grupo & RH</th>
													<th>Condiciones de Paciente</th>
													<th style={{textAlign:'center'}}>Muestra</th>
													<th style={{textAlign:'center'}}>Laboratorio</th>
													<th style={{textAlign:'center'}}>Reserva</th>
													<th style={{textAlign:'center'}}>Envio</th>
												</tr>
											</thead>
											<tbody>
												{this.state.petitions.map((p, i)=>(
													
													this.filter(p) ?
														<tr key={i} style={p.status === 'CANCELADA' ?  {backgroundColor: '#ffe6e6'} : {} }>
															<td>
																{moment(p.petition_date).format('DD/MM/YYYY')+' '+
																moment(p.petition_hour, 'H:mm:ss').format('HH:mm')}
															</td>
															<td>{p.id}</td>
															<td>{p.name}</td>
															<td>
																{p.g_rh.length === 1 ?
																	p.g_rh.map((gpo, i)=>(
																		gpo.group+
																		(gpo.rh === 'POSITIVO' ? '+' :
																		gpo.rh === 'NEGATIVO' ? '-' : '')
																	))
																: p.type === "COMPONENTS" ||
																	p.type === 'LABORATORY' || 
																	p.type === 'STUDY_HLA' ?  
																		<SvgIcon size={25} icon={drop} 
																		style={{cursor:'pointer'}}
																		onClick={(e)=>this.openGroups(e, p.g_rh)}
																		/>
																:null}
															</td>
															<td>
																{p.conditions.map((c, i) => (
																	<div key={i}>
																		{c}
																	</div>
																))}
															</td>
															<td style={{textAlign:'center'}}>
																{p.type === "COMPONENTS" ||
																p.type === 'LABORATORY' || 
																p.type === 'STUDY_HLA' ? 
																	/*<SvgIcon size={25} icon={clipboard} 
																		style={{cursor:'pointer'}}
																		style={p.flag_samples === 'NO_SAMPLES' ?
																				{cursor:'pointer', color:'#a39f9f'}
																			: p.flag_samples === 'WITH_SAMPLES' ?
																				{cursor:'pointer', color:'rgb(var(--primary))'}
																			: {cursor:'pointer', color:'rgba(var(--primary), 0.5)'}
																		} 
																		onClick={this.newSample.bind(this, p.id, this.state.patient_id)}
																		/>*/
																	p.g_rh.map((g)=>(
																		g.samples.map((s, i)=>(
																			<div key={i}>
																				<a style={{cursor:'pointer'}}
																					onClick={p.status === 'CANCELADA' ? (e) => { e.preventDefault(); } : this.newSample.bind(this, p.id, this.state.patient_id, s.id)}>
																					{s.number}
																				</a>
																			</div>
																		))
																	))
																	
																: null}
															</td>
															<td align="center">
																{p.type === "COMPONENTS" ||
																	p.type === 'LABORATORY' || 
																	p.type === 'STUDY_HLA' ? 
																	<a href="" className={p.flag_samples === 'NO_SAMPLES' ? "disabled":"" } 
																		style={p.status === 'CANCELADA' ? { cursor: 'no-drop' } : {}}

																		disabled={p.flag_samples === 'NO_SAMPLES' || p.status === 'CANCELADA'}
																		onClick={p.status === 'CANCELADA' ? (e) => { e.preventDefault(); } : (e)=>this.sampleResults(e,p)}>
																		<Icon width={25} title="Grupo & RH"
																			fill={p.validations === 'INCOMPLETE' ? 
																					'rgba(var(--primary), 0.5)' :
																				p.validations === 'COMPLETE' ?
																					'rgb(var(--primary))' :
																				'#a39f9f'}
																		/>
																		
																	</a>
																	/*<a href="" className={p.flag_samples === 'NO_SAMPLES' ? "disabled":"" } 
																		disabled={p.flag_samples === 'NO_SAMPLES'}
																		onClick={(e)=>this.sampleResults(e,p)}>
																		<Icon width={25} title="Grupo & RH"*/
																			/*fill={p.validations === 'INCOMPLETE' ? 
																					'rgba(var(--primary), 0.5)' :
																				p.validations === 'COMPLETE' ?
																					'rgb(var(--primary))' :
																				'#a39f9f'}
																		/>													
																	</a>*/
																: null}
															</td>
															<td align="center">
																{p.type === "COMPONENTS" ?
																	<SvgIcon icon={download2} 
																		style={p.status === 'CANCELADA' ?
																				{cursor:'no-drop', color:'#a39f9f'}
																			:!p.flag_reserved ?
																				{cursor:'pointer', color:'#a39f9f'}
																			: {cursor:'pointer', color:'rgb(var(--primary))'}}
																		size={30} 
																		onClick={p.status !== 'CANCELADA' ? (e)=>this.unitReserve(e, p.id) : (e)=>e.preventDefault}/>
																	/*<SvgIcon icon={download2} 
																		style={{cursor:'pointer'}}
																		style={!p.flag_reserved ?
																				{cursor:'pointer', color:'#a39f9f'}
																			: {cursor:'pointer', color:'rgb(var(--primary))'}}
																		size={30} 
																		onClick={(e)=>this.unitReserve(e, p.id)}/>*/
																: null}
															</td>
															<td align="center">
																{p.type === "COMPONENTS" ?
																	<SvgIcon icon={upload2} size={30} 
																		title="Enviado" 
																		onClick={p.status !== 'CANCELADA' ? (e)=>this.sendUnits(e, p.id) : (e)=>e.preventDefault}
																		style={p.status === 'CANCELADA' ?
																			{cursor:'no-drop', color:'#a39f9f'}
																		:!p.flag_delivered ?
																			{cursor:'pointer', color:'#a39f9f'}
																		: {cursor:'pointer', color:'rgb(var(--primary))'}}/>

																	/*<SvgIcon size={25} icon={upload2} size={30} 
																		title="Enviado"
																		style={{cursor:'pointer'}}
																		onClick={(e)=>this.sendUnits(e, p.id)}
																		style={!p.flag_delivered ?
																				{cursor:'pointer', color:'#a39f9f'}
																			: {cursor:'pointer', color:'rgb(var(--primary))'}}/>*/
																:p.type === 'PLASMATIC_PRODUCTS'  ?
																	<SvgIcon size={25} icon={upload2} size={30} 
																		title="Enviado" 
																		onClick={p.status !== 'CANCELADA' ? (e)=>this.sendProducts(e, p.id ) : (e)=>e.preventDefault}
																		style={p.status === 'CANCELADA' ?
																				{cursor:'no-drop', color:'#a39f9f'}
																			:!p.flag_delivered ?
																				{cursor:'pointer', color:'#a39f9f'}
																			: {cursor:'pointer', color:'rgb(var(--primary))'}}/>

																	/*<SvgIcon size={25} icon={upload2} size={30} 
																		title="Enviado" onClick={(e)=>this.sendProducts(e, p.id)}
																		style={{cursor:"pointer"}}/>*/
																:null}
															</td>
														</tr>
													:null
												))}
											</tbody>
										</Table>
									</div>
					
								</Panel.Body>
							</Panel.Collapse>
						</Panel>

						<Panel id="samples-panel">
							<Panel.Heading style={{
									background: this.state.samples.length > 0 ? 'var(--base1)' : '',
									color: this.state.samples.length > 0 ? 'var(--color-active)' : ''
								}}>
								<Panel.Title toggle={this.state.samples.length > 0 ? true : false}>
									Muestras
								</Panel.Title>
							</Panel.Heading>

							<Panel.Collapse>
								<Panel.Body>
									<Table responsive hover>
										<thead>
											<tr>
												<th>No. Petición</th>
												<th>No. Muestra</th>
												<th>Fecha/Hr Muestra</th>
												<th>Grupo/Rh Muestra</th>
												<th>Usuario Registro</th>
												<th>Usuario Valido</th>
											</tr>
										</thead>
										<tbody>
											{this.state.samples.map((s, i)=>(
												<tr key={i}>
													<td>{s.petition_number}</td>
													<td>{s.sample_number}</td>
													<td>{moment(s.timestamp).format('DD/MM/YYYY HH:mm')}</td>
													<td>{s.group_rh}</td>
													<td>{s.user_register}</td>
													<td>{s.user_valid != null? s.user_valid.user:null}</td>
												</tr>
											))}
										</tbody>
									</Table>
								</Panel.Body>
							</Panel.Collapse>
						</Panel>

					
						<Panel id="reserves-panel">
							<Panel.Heading style={{
									background: this.state.reserves.length > 0 ? 'var(--base1)' : '',
									color: this.state.reserves.length > 0 ? 'var(--color-active)' : ''
								}}>
								<Panel.Title toggle={this.state.reserves.length > 0 ? true : false}>
									Reservas
								</Panel.Title>
							</Panel.Heading>
							<Panel.Collapse>
								<Panel.Body>
									<Table responsive hover>
										<thead>
											<tr>
												<th>No. Petición</th>
												<th>Fecha/Hr</th>
												<th>No. Muestra</th>
												<th>Fecha/Hr Muestra</th>
												<th>Grupo/Rh Muestra</th>
												<th>No. Unidad</th>
												<th>Código</th>
												<th>Componente</th>
												<th>Grupo/Rh Unidad</th>
												<th>Compatibilidad</th>
												<th>Estatus</th>
												<th>Enviada</th>
											</tr>
										</thead>
										<tbody>
											{this.state.reserves.map((s, i)=>(
												<tr key={i}>
													<td>{s.petition_number}</td>
													<td>{moment(s.petition_timestamp).format('DD/MM/YYYY HH:mm')}</td>
													<td>{s.sample_number}</td>
													<td>{s.sample_timestamp !== null ? moment(s.sample_timestamp).format('DD/MM/YYYY HH:mm') : ""}</td>
													<td>{s.sample_grh}</td>
													<td>{s.unit_number}</td>
													<td>{s.component_number}</td>
													<td>{s.component}</td>
													<td>{s.unit_grh}</td>
													<td>{s.compatibility}</td>
													<td>{s.status}</td>
													<td>{s.delivered}</td>
												</tr>
											))}
										</tbody>
									</Table>
								</Panel.Body>
							</Panel.Collapse>
						</Panel>

						<Panel id="delivered-panel">
							<Panel.Heading style={{
									background: this.state.deliveries.length > 0 ? 'var(--base1)' : '',
									color: this.state.deliveries.length > 0 ? 'var(--color-active)' : ''
								}}>
								<Panel.Title toggle ={this.state.deliveries.length > 0 ? true : false}>
									Envíos
								</Panel.Title>
							</Panel.Heading>
							<Panel.Collapse>
								<Panel.Body>
									<Table responsive hover>
										<thead>
											<tr>
												<th>Fecha/Hr</th>
												<th>Folio Envío</th>
												<th>Unidad</th>
												<th>Tipo de Componente</th>
												<th>Volumen</th>
												<th>Componente</th>
												<th>Destino</th>
											</tr>
										</thead>
										<tbody>
											{this.state.deliveries.map((d, i)=>(
												<tr key={i}>
													<td>{moment(d.delivered_date).format('DD/MM/YYYY HH:mm')}</td>
													<td>{d.folio}</td>
													<td>{d.unit_number}</td>
													<td>{d.component_code}</td>
													<td>{d.volume}</td>
													<td>{d.component_number}</td>
													<td>{d.final_center}</td>
												</tr>
											))}
										</tbody>
									</Table>
								</Panel.Body>
							</Panel.Collapse>
						</Panel>
					</div>

					{this.state.patient_id !== "" &&
						<div className="col-xs-12" style={{textAlign:"center"}}>
							<button className="toolIcon" onClick={this.onPrint}>
								<SvgIcon size={40} icon={print} />
								<div>
									<span>Imprimir</span>
								</div>
							</button>
						</div>
					}
							
					
					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			onClick={this.onReturn}  style={{margin:12}}/>
		        	</div>
				</form>

				<ModalSample {...this.props} onRef={ref => this.modal_sample = ref}/>
				<ModalUserTraceability {...this.props} onRef={ref => (this.modal_user_traceability = ref)} />
				<ModalSampleResult {...this.props} onRef={ref => (this.modal_sample_result = ref)} />
				<ModalReserve {...this.props} onRef={ref => this.modal_reserve = ref} />
				<ModalSend {...this.props} onRef={ref => this.modal_send = ref} />
				<ModalGpoRh {...this.props} onRef={ref => this.modal_group = ref} />
				<ModalGeneralTraceability {...this.props} onRef={ref => this.modal_general_traceability = ref} />
				<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} patient={this.state.patient_id} />
				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					updatePerson={this.patientSelected} 
					onRef={ref => (this.modal_person_search = ref)} 
					search={this.patientSelected}
					persons={this.state.patients}
				/>
				<ModalConditions {...this.props} 					
					onRef={ref => this.modal_conditions = ref} 
				/>
			</div>
		)
	}

}

export default translate('translations')(PatientSearch);